module.exports = __webpack_public_path__ + "img/info2.f88e7ae1.png";